import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FinancialStatementLayout from '../common/financial-statement-table/FinancialStatementLayout';
import { TABS } from '../Const';
import { fetchIncomeStatement, REDUCER_NAME } from '../reducer';
import BankingChart from './BankingChart';
import Chart from './Chart';
import InsuranceChart from './InsuranceChart';

class IncomeStatement extends PureComponent {
  getDataFromRedux = state => {
    try {
      const { timeKey, componentId } = this.props;

      return state[REDUCER_NAME][componentId].incomeStatement.data[timeKey]
        .dataByIds;
    } catch (e) {
      return {};
    }
  };

  getChartComponent = () => {
    const { currentSearch } = this.props;
    const mapChartComponent = {
      NH: BankingChart,
      BH: InsuranceChart,
    };

    return mapChartComponent[currentSearch.comTypeCode] || Chart;
  };

  render() {
    const {
      isLoading,
      ids,
      fields,
      timeKey,
      dataByIds,
      fetchIncomeStatement,
      organCode,
      locale,
      size,
      componentId,
      rawData,
    } = this.props;

    const ChartComponent = this.getChartComponent();
    return (
      <FinancialStatementLayout
        timeKey={timeKey}
        rawData={rawData}
        getDataFromRedux={this.getDataFromRedux}
        isLoading={isLoading}
        ids={ids}
        fields={fields}
        fetchData={fetchIncomeStatement}
        dataByIds={dataByIds}
        tab={TABS.INCOME_STATEMENT}
        organCode={organCode}
        componentId={componentId}
      >
        {(skip, numberColumn) => (
          <ChartComponent
            numberColumn={numberColumn}
            locale={locale}
            timeKey={timeKey}
            width={size.width}
            fields={fields}
            dataByIds={dataByIds}
            skip={skip}
          />
        )}
      </FinancialStatementLayout>
    );
  }
}

const defaultProps = {
  ids: [],
  fields: [],
  dataByIds: {},
  isBanking: false,
  isInsurance: false,
  isLoading: false,
  size: {},
};

IncomeStatement.propTypes = {
  fetchIncomeStatement: PropTypes.func.isRequired,
  ids: PropTypes.array.isRequired,
  organCode: PropTypes.string,
  timeKey: PropTypes.string.isRequired,
  fields: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  i18nPrefix: PropTypes.string,
  size: PropTypes.object.isRequired,
  locale: PropTypes.string,
  componentId: PropTypes.number.isRequired,
};

const mapStateToProps = (state, { timeKey, componentId }) => {
  try {
    return {
      currentSearch: state[REDUCER_NAME][componentId].currentSearch,
      ids: state[REDUCER_NAME][componentId].incomeStatement.data[timeKey].ids,
      fields:
        state[REDUCER_NAME][componentId].incomeStatement.data[timeKey].fields,
      dataByIds:
        state[REDUCER_NAME][componentId].incomeStatement.data[timeKey]
          .dataByIds,
      isLoading: state[REDUCER_NAME][componentId].incomeStatement.isLoading,
      rawData: state[REDUCER_NAME][componentId].incomeStatement.rawData,
      size: state[REDUCER_NAME][componentId].size,
      locale: state.i18n.locale,
    };
  } catch (e) {
    return defaultProps;
  }
};

const mapDispatchToProps = {
  fetchIncomeStatement,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(IncomeStatement);
